import React from 'react';
import { motion } from 'framer-motion';
import { ProductCard } from '../ui/product-card';
import { Zap, Sparkles, Mic } from 'lucide-react';
export function Products() {
  const products = [{
    title: 'Never Miss Another Deal',
    tagline: '2.3 second response time',
    description: "While you're showing homes, our AI engages every lead instantly. Convert 3x more prospects with intelligent conversations that qualify, nurture, and book appointments 24/7.",
    icon: Zap,
    accent: 'sage' as const,
    shapeType: 'square' as const
  }, {
    title: 'Inbox on Autopilot',
    tagline: 'Save 10+ hours per week',
    description: 'Draft-Bot handles routine emails, follow-ups, and scheduling. Review and send with one click. Focus on closing deals, not clearing emails.',
    icon: Sparkles,
    accent: 'indigo' as const,
    shapeType: 'diamond' as const
  }, {
    title: 'Commute Like a CEO',
    tagline: 'Hands-free productivity',
    description: 'Transform dead time into deal time. Review, edit, and approve emails with simple voice commands while driving. Stay ahead without touching your phone.',
    icon: Mic,
    accent: 'indigo' as const,
    shapeType: 'hexagon' as const
  }];
  return <motion.section id="product" className="relative overflow-hidden bg-linen-50 py-16 sm:py-24" data-id="element-612">
      <div className="container relative" data-id="element-613">
        {/* Section header with fade-in */}
        <motion.div className="mb-16 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} data-id="element-614">
          <h2 className="font-display text-5xl md:text-6xl mb-4 text-slate-900" data-id="element-615">
            Work Smarter, Not Harder
          </h2>
          <p className="text-xl font-medium text-muted-foreground max-w-2xl mx-auto" data-id="element-616">
            AI-powered tools that transform how real estate agents work
          </p>
        </motion.div>

        {/* Clean 3-Column Grid */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-617">
          {products.map((product, index) => <ProductCard key={index} {...product} delay={index} data-id="element-618" />)}
        </div>
      </div>
    </motion.section>;
}